import { render, staticRenderFns } from "./XszxList.vue?vue&type=template&id=b8e27798&scoped=true"
import script from "./XszxList.vue?vue&type=script&lang=js"
export * from "./XszxList.vue?vue&type=script&lang=js"
import style0 from "./XszxList.vue?vue&type=style&index=0&id=b8e27798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e27798",
  null
  
)

export default component.exports